import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';

export default class Divider extends React.Component {
  static propTypes = {
    style: PropTypes.object,
    x1: PropTypes.number,
    x2: PropTypes.number,
    y1: PropTypes.number,
    y2: PropTypes.number,
  };

  static defaultProps = {
    style: {},
    x1: 0,
    x2: 0,
    y1: 0,
    y2: 0,
  };

  render() {
    return (
      <line
        className={styles.Divider}
        style={this.props.style}
        x1={this.props.x1}
        x2={this.props.x2}
        y1={this.props.y1}
        y2={this.props.y2}
      />
    );
  }
}
